import { render, staticRenderFns } from "./DownloadStudyView.vue?vue&type=template&id=0a84a667&scoped=true&"
import script from "./DownloadStudyView.vue?vue&type=script&lang=js&"
export * from "./DownloadStudyView.vue?vue&type=script&lang=js&"
import style0 from "./DownloadStudyView.vue?vue&type=style&index=0&id=0a84a667&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a84a667",
  null
  
)

export default component.exports